module.exports = __webpack_public_path__ + "static/media/cdyy.e2f66ff7.mp4";